import { render, staticRenderFns } from "./VenueView_PurchaseOrders.vue?vue&type=template&id=24edc8a2&"
import script from "./VenueView_PurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./VenueView_PurchaseOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports